import { type RPPCore } from '@retailer-platform/dashboard/core'
import AuthenticationDomain from '@retailer-platform/domain-authentication/domainDefinition'
import NotificationsDomain from '@retailer-platform/domain-notifications/domainDefinition'
import InsightsPortalDomain from '@retailer-platform/domain-insights-portal/domainDefinition'
import IntegrationsDomain from '@retailer-platform/domain-integrations/domainDefinition'
import PickupSettingsDomain from '@retailer-platform/domain-pickup-settings/domainDefinition'
import StoreHoursBulkDomain from '@retailer-platform/domain-store-hours-bulk/domainDefinition'
import ShoppingListDomain from '@retailer-platform/domain-shopping-list/domainDefinition'
import ConfigurableProductsDomain from '@retailer-platform/domain-configurable-products/domainDefinition'
import FulfillmentTestingCenterDomain from '@retailer-platform/domain-fulfillment-testing-center/domainDefinition'
import RetailerCollectionsDomain from '@retailer-platform/domain-retailer-collections/domainDefinition'
import StorefrontDomain from '@retailer-platform/domain-storefront/domainDefinition'
import OnboardingDomain from '@retailer-platform/domain-onboarding/domainDefinition'
import CampaignManagementDomain from '@retailer-platform/domain-campaign-management/domainDefinition'
import WebhookConfigurationDomain from '@retailer-platform/domain-webhook-configuration/domainDefinition'
import RetailerFundedMarketingDomain from '@retailer-platform/domain-retailer-funded-marketing/domainDefinition'
import RoleManagementDomain from '@retailer-platform/domain-role-management/domainDefinition'
import AuditLogsDomain from '@retailer-platform/domain-audit-logs/domainDefinition'
import CustomersDomain from '@retailer-platform/domain-customers/domainDefinition'

export const registerDomains = (app: RPPCore) => {
  app.attachDomain(AuthenticationDomain)
  app.attachDomain(NotificationsDomain)
  app.attachDomain(InsightsPortalDomain)
  app.attachDomain(IntegrationsDomain)
  app.attachDomain(PickupSettingsDomain)
  app.attachDomain(StoreHoursBulkDomain)
  app.attachDomain(ShoppingListDomain)
  app.attachDomain(ConfigurableProductsDomain)
  app.attachDomain(FulfillmentTestingCenterDomain)
  app.attachDomain(RetailerCollectionsDomain)
  app.attachDomain(StorefrontDomain)
  app.attachDomain(OnboardingDomain)
  app.attachDomain(CampaignManagementDomain)
  app.attachDomain(WebhookConfigurationDomain)
  app.attachDomain(RetailerFundedMarketingDomain)
  app.attachDomain(RoleManagementDomain)
  app.attachDomain(AuditLogsDomain)
  app.attachDomain(CustomersDomain)
}
